import * as listingAllHotels from './datalayer/listingAllHotels'
import MainSlider from './datalayer/MainSlider'
import PromoTimer from './datalayer/PromoTimer'
import ReservationForm from './datalayer/ReservationForm'
import TopOffer from './datalayer/TopOffer'

import isInViewport from '@/helpers/isInViewport'
import { DataLayerEvent, pushEvent } from '@/modules/datalayer/helpers'

function ensureDataLayerIsDefined () {
  window.dataLayer = window.dataLayer || []
}

export function init () {
  ensureDataLayerIsDefined()

  ReservationForm.forms.forEach(form => new ReservationForm(form))
  TopOffer.links.forEach(link => new TopOffer(link))
  PromoTimer.links.forEach(link => new PromoTimer(link))
  MainSlider.links.forEach(link => new MainSlider(link))

  MainSlider.allItems.forEach(item => {
    item.addEventListener('click', () => {
      const name = item.dataset.name || ''
      /* eslint-disable */
      const eventData = {
        promotion_id: name,
        promotion_name: name,
        creative_name: name + '_slide',
        creative_slot: 'mainSlider',
      }
      const [ event ] = DataLayerEvent.selectPromotion(eventData)
      pushEvent(event)
      /* eslint-enable */
    })

    const viewed = []
    const observer = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('active') &&
          !viewed.includes(mutation.target)
        ) {
          if (mutation.target && isInViewport(mutation.target)) {
            viewed.push(mutation.target)
            const name = mutation.target.dataset.name || ''
            /* eslint-disable */
            const eventData = {
              promotion_id: name,
              promotion_name: name,
              creative_name: name + '_slide',
              creative_slot: 'mainSlider',
            }
            /* eslint-enable */
            const [ event ] = DataLayerEvent.viewPromotion(eventData)
            pushEvent(event)
          }
        }
      })
    })
    observer.observe(item, { attributes: true })
  })

  listingAllHotels.init()
}



// WEBPACK FOOTER //
// ./src/modules/datalayer.js